var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._32uGO{position:relative;width:100%}._1vqgC{height:50px}._1vqgC .Z8Ifi{height:50px;width:310px;margin:0 auto;background-image:url(" + escape(require("../../assets//images/daily_banner_large.png")) + ")}._1fyv8{height:48px}._1fyv8 .Z8Ifi{height:48px;width:280px;margin:0 auto;background-image:url(" + escape(require("../../assets//images/daily_banner_normal.png")) + ")}._28EzQ{height:0;overflow:hidden}.Z8Ifi{position:relative;max-width:100%;cursor:pointer}.Z8Ifi,.Z8Ifi i{background-repeat:no-repeat;background-position:50%;background-size:contain}.Z8Ifi i{width:11px;height:11px;position:absolute;right:2.5%;top:14%;background-image:url(" + escape(require("../../assets/images/icon_close.png")) + ")}._1E7aV{position:fixed;bottom:50px;left:0;background-color:#404040}._32uGO ._1yhU9{width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"daily-note": "_32uGO",
	"daily-note-large": "_1vqgC",
	"daily-note-banner": "Z8Ifi",
	"daily-note-normal": "_1fyv8",
	"daily-note-small": "_28EzQ",
	"daily-note-fixed": "_1E7aV",
	"placeholder": "_1yhU9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/components/DailyNote/DailyNote.scss
// module id = T6O9
// module chunks = 3